export const apiCreate = (): string => '/partnerships/promoters/'
export const apiList = (id?: string): string =>
  !id ? '/partnerships/promoters/' : `/partnerships/promoters/view/${id}`
export const apiGetByIdUpdatePage = (id: string): string =>
  `/partnerships/promoters/getByIdUpdatePage/${id}`
export const apiUpdate = (id: string): string =>
  `/partnerships/promoters/update/${id}`
export const apiDelete = (id: string): string => `/partnerships/promoters/${id}`

export const apiListPromotersOptions = (): string =>
  '/partnerships/promoters/options'
